export const PAGINATION_OPTIONS = [
  { value: "10", content: "10" },
  { value: "20", content: "20" },
  { value: "50", content: "50" },
  { value: "100", content: "100" },
];
